import { createFileRoute } from '@tanstack/react-router';
import { MyOrgFunctionsPage } from '@/pages/org-functions/MyOrgFunctionsPage';
import { createCaslGuard } from '@/lib/auth/permissionGuards';
import { dataTableSearchSchema } from '@/lib/validation/dataTableSearchSchema';

export const Route = createFileRoute('/$slug/org-functions/')({
  component: MyOrgFunctionsPage,
  beforeLoad: createCaslGuard('MyOrgFunctions'),
  validateSearch: dataTableSearchSchema({})
});
